import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import playIcon from "../../../assets/icon/play.svg";
import { Formik } from "formik";
import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import searchIcon from "../../../assets/icon/search.svg";
import iconStatus from "../../../assets/icon/status-save-icon.svg";
import sortIcon from "../../../assets/icon/sort-arrow.svg";
import columnSelectorIcon from "../../../assets/icon/column-selector.svg";
import applyIcon from "../../../assets/icon/apply.svg";
import resetAllIcon from "../../../assets/icon/resetall.svg";
import { useNavigate } from "react-router-dom";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import SearchButtons from "components/SearchButtons";
import { cellRendererCheck } from "utils/columns";
import DescriptionShort from "components/DescriptionShort";

const rowData = [
  {
    id: 1,
    status: "New (Waiting)",
    due: "12:23 PM ",
    rx: "RX7203709 ",
    entered: "11:23 AM ",
    patient: "Doe, John ",
    medication: "Venlafaxine ER Tablet 150MG",
  },
  {
    id: 2,
    status: "Due Soon ",
    due: "12:28 PM  ",
    rx: "RX7203710 ",
    entered: "11:28 AM ",
    patient: "Wright, Emma  ",
    medication: "Metformin HCL Tablet 500MG ",
  },
  {
    id: 3,
    status: "NDC Change",
    due: "12:33 PM  ",
    rx: "RX7203709 ",
    entered: "11:33 AM",
    patient: "Nguyen, Jessica",
    medication: "Levothyroxine Sodium Tablet 75MCG  ",
  },
  {
    id: 4,
    status: "Due Soon  ",
    due: "12:38 PM  ",
    rx: "RX7203712 ",
    entered: "11:38 AM ",
    patient: "Clark, Lucas",
    medication: "Gabapentin Capsule 300MG  ",
  },
  {
    id: 5,
    status: "Due Soon  ",
    due: "12:43 PM  ",
    rx: "RX7203713  ",
    entered: "11:43 AM ",
    patient: "Kim, Noah ",
    medication: "Sertraline HCL Tablet 100MG ",
  },
  {
    id: 6,
    status: "New  ",
    due: "12:48 PM  ",
    rx: "RX7203714 ",
    entered: "11:48 AM  ",
    patient: "Clark, Benjamin ",
    medication: "Omeprazole DR Capsule 20MG  ",
  },
  {
    id: 7,
    status: "New  ",
    due: "12:53 PM  ",
    rx: "RX7203715  ",
    entered: "11:53 AM ",
    patient: "Young, Jessica ",
    medication: "Amlodipine Besylate Tablet 10MG ",
  },
  {
    id: 8,
    status: "New  ",
    due: "12:58 PM ",
    rx: "RX7203716 ",
    entered: "11:58 AM ",
    patient: "Adams, Ava ",
    medication: "Losartan Potassium Tablet 50MG",
  },
  {
    id: 9,
    status: "New  ",
    due: "1:03 PM  ",
    rx: "RX7203717  ",
    entered: "12:03 PM",
    patient: "Hill, Jessica ",
    medication: "Hydrochlorothiazide Tablet 25MG",
  },
  {
    id: 10,
    status: "New  ",
    due: "1:08 PM ",
    rx: "RX7203718 ",
    entered: "12:08 PM ",
    patient: "Harris, Mason  ",
    medication: "Simvastatin Tablet 40MG ",
  },

  {
    id: 11,
    status: "New  ",
    due: "1:13 PM ",
    rx: "RX7203719 ",
    entered: "12:13 PM  ",
    patient: "Patel, Mia  ",
    medication: "Alprazolam Tablet 0.5MG ",
  },
  {
    id: 12,
    status: "New  ",
    due: "1:18 PM  ",
    rx: "RX7203720  ",
    entered: "12:18 PM    ",
    patient: "Kim, Ethan  ",
    medication: "Escitalopram Oxalate Tablet 10MG ",
  },
  {
    id: 13,
    status: "New  ",
    due: "1:23 PM  ",
    rx: "RX7203721 ",
    entered: "12:23 PM  ",
    patient: "Hill, Lucas  ",
    medication: "Fluoxetine HCL Capsule 20MG ",
  },
  {
    id: 14,
    status: "New  ",
    due: "1:28 PM  ",
    rx: "RX7203722  ",
    entered: "12:28 PM  ",
    patient: "King, Luna ",
    medication: "Citalopram HBR Tablet 20MG ",
  },
  {
    id: 15,
    status: "New  ",
    due: "1:33 PM  ",
    rx: "RX7203724 ",
    entered: "12:33 PM  ",
    patient: "Young, Aria   ",
    medication: "Clonazepam Tablet 0.5MG ",
  },
  {
    id: 16,
    status: "New  ",
    due: "1:38 PM  ",
    rx: "RX7203724 ",
    entered: "12:38 PM   ",
    patient: "Allen, Lucas ",
    medication: "Tramadol HCL Tablet 50MG ",
  },
  {
    id: 17,
    status: "New  ",
    due: "1:43 PM  ",
    rx: "RX7203725  ",
    entered: "12:43 PM   ",
    patient: "Patel, Lucas  ",
    medication: "Trazodone HCL Tablet 100MG  ",
  },
  {
    id: 18,
    status: "New  ",
    due: "1:48 PM   ",
    rx: "RX7203726 ",
    entered: "12:48 PM   ",
    patient: "Kim, Aarav ",
    medication: "Duloxetine DR Capsule 30MG ",
  },

  {
    id: 19,
    status: "New  ",
    due: "1:48 PM   ",
    rx: "RX7203727 ",
    entered: "12:53 PM  ",
    patient: "Nguyen, Luna ",
    medication: "Bupropion HCL XL Tablet 150MG ",
  },

  {
    id: 20,
    status: "New  ",
    due: "1:58 PM    ",
    rx: "RX7203726  ",
    entered: "12:58 PM     ",
    patient: "Walker, Emma  ",
    medication: "Loratadine Tablet 10MG  ",
  },
  {
    id: 215,
    status: "New  ",
    due: "2:03 PM ",
    rx: "RX7203729   ",
    entered: "1:03 PM     ",
    patient: "Taylor, Mia  ",
    medication: "Cetirizine HCL Tablet 10MG  ",
  },
  {
    id: 212,
    status: "New  ",
    due: "2:08 PM  ",
    rx: "RX7203730   ",
    entered: "1:08 PM     ",
    patient: "White, Mia  ",
    medication: "Prednisone Tablet 20MG  ",
  },
  {
    id: 22,
    status: "New  ",
    due: "2:13 PM ",
    rx: "RX7203731  ",
    entered: "1:13 PM    ",
    patient: "Allen, Kevin ",
    medication: "Propranolol HCL Tablet 40MG  ",
  },
  {
    id: 22,
    status: "New  ",
    due: "2:18 PM  ",
    rx: "RX7203732  ",
    entered: "1:18 PM    ",
    patient: "Hill, Jacob  ",
    medication: "Topiramate Tablet 25MG ",
  },
  {
    id: 2255,
    status: "New  ",
    due: "2:23 PM   ",
    rx: "RX7203733   ",
    entered: "1:23 PM    ",
    patient: "Scott, Jessica   ",
    medication: "Lamotrigine Tablet 100MG  ",
  },
];
const renderBtn = (rowData) => {
  return <VerticalStatusPopover row={rowData} />;
};

const colData = [
  {
    dataField: "status",
    text: "Order Status",
    show: true,
    width: 100,
    sort: true,
    cellRenderer: (rowData) => renderBtn(rowData),
  },
  {
    dataField: "due",
    text: "Due",
    show: true,
    width: 80,
    sort: true,
  },
  {
    dataField: "entered",
    text: "Entered",
    show: true,
    width: 60,
    sort: true,
  },
  {
    dataField: "rx",
    text: "Rx Number",
    show: true,
    width: 80,
    sort: true,
  },
  {
    dataField: "patient",
    text: "Patient Name",
    show: true,
    sort: true,
    // cellRenderer: (rowData) => (
    //   <a href="/initial-patient-details" style={{ color: "#212529" }}>
    //     {rowData.patient}
    //   </a>
    // ),
    width: 100,
  },

  {
    dataField: "medication",
    text: "Medication",
    show: true,
    width: 200,
    sort: true,
  },
];

const InitialReviewPage = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [updateData, setUpdateData] = useState([]);
  const [data, setData] = useState([]);
  // const [searchData, setSearchData] = useState("");
  // const [filterData, setFilterData] = useState(data);
  const navigate = useNavigate();
  const [rSelected, setRSelected] = useState("off");

  const [check, setCheck] = useState([
    {
      selectall: "",
      status: "",
      due: "",
      entered: "",
      rx: "",
      patient: "",
      medication: "",
    },
  ]);

  const handleRowClick = (row) => {
    navigate(`/workflow-initial-patient-details/${row.id}`, { state: row });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        status: checked,
        due: checked,
        patient: checked,
        rx: checked,
        medication: checked,
        entered: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        //const icon = patient.status === purpleCrossIcon ? purpleCrossIcon : iconStatus;

        return {
          id: patient.id,
          status: (
            <>
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),
          id: patient.id,
          status: patient.status,
          due: patient.due,
          rx: patient.rx,
          entered: patient.entered,
          patient: patient.patient,
          medication: patient.medication,
        };
      })
    : [
        {
          id: "",
          status: "",
          due: "",
          rx: "",
          entered: "",
          patient: "",
          medication: "",
        },
      ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 0;
        if (key === "due") return 1;
        if (key === "entered") return 2;
        if (key === "rx") return 3;
        if (key === "patient") return 4;
        if (key === "medication") return 5;
        return -1;
      })
      .filter((index) => index !== -1);
    return colData.filter((_, index) => columnIndexes.includes(index));
  };

  const filteredColData = filterColumns();
  const totalCount = [
    check.status,
    check.due,
    check.entered,
    check.rx,
    check.patient,
    check.medication,
  ].filter(Boolean).length;
  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colData);
    setColumnOpen(false);
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div className=" table-card scroll-table position-relative layout-alignment border-0 rounded bg-white pb-0">
      <div className="heading-text section-devider-border pb-2 mb-1">
        Initial Review Queue
      </div>
      <Formik>
        <Row className="mt-2">
          <Col
            className="d-flex justify-content-start "
            style={{ gap: "12px" }}
          >
            <SearchButtons
              InSize={320}
              placeHolder={"Search by Product name"}
              data={tableData}
              row={rowData}
              setFilterData={setTableData}
            />
            <Dropdown isOpen={columnOpen} toggle={() => setColumnOpen(true)}>
              <DropdownToggle className="clmn">
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {totalCount > 0 && (
                    <div className="totalcount">{totalCount}</div>
                  )}
                </span>
              </DropdownToggle>
              <DropdownMenu className="drop-down-clm">
                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="selectall"
                    value={check.selectall}
                    onChange={handleCheck}
                    checked={check.selectall}
                  />
                  <span className="m-2">Select All</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="status"
                    value={check.status}
                    onChange={handleCheck}
                    checked={check.status}
                  />
                  <span className="m-2">Order Status</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="due"
                    value={check.due}
                    onChange={handleCheck}
                    checked={check.due}
                  />
                  <span className="m-2">Due</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="rx"
                    value={check.rx}
                    onChange={handleCheck}
                    checked={check.rx}
                  />
                  <span className="m-2">Rx number</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border">
                  <Input
                    type="checkbox"
                    name="patient"
                    value={check.patient}
                    onChange={handleCheck}
                    checked={check.patient}
                  />
                  <span className="m-2">Patient Name</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="medication"
                    value={check.medication}
                    onChange={handleCheck}
                    checked={check.medication}
                  />
                  <span className="m-2">Medication</span>
                </DropdownItem>

                <DropdownItem className="dropdownitem-border drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="entered"
                    value={check.entered}
                    onChange={handleCheck}
                    checked={check.entered}
                  />
                  <span className="m-2">Entered</span>
                </DropdownItem>

                <div className="d-flex justify-content-center align-items-center p-2">
                  <Button
                    onClick={() =>
                      setCheck({
                        selectall: false,
                        status: false,
                        due: false,
                        medication: false,
                        rx: false,
                        patient: false,
                        entered: false,
                      })
                    }
                  >
                    {" "}
                    <img src={resetAllIcon} alt="" /> Reset All
                  </Button>
                  <Button
                    color="primary"
                    onChange={handleCheck}
                    onClick={handleSubmit}
                  >
                    {" "}
                    <img src={applyIcon} alt="" /> Apply
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="f-16 font-weight-600">Filter</span>
              <ButtonGroup className="filter-btn-group">
                <Button
                  color="info"
                  outline
                  onClick={toggleFilter}
                  active={rSelected === "off"}
                >
                  OFF
                </Button>
                <Button
                  color="info"
                  outline
                  active={rSelected === "on"}
                  onClick={toggleFilter}
                >
                  ON
                </Button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Formik>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="initialreview"
          data={tableFilterData}
          row={rowData}
          columns={updateData.length > 0 ? updateData : colData}
          handleRowClick={handleRowClick}
          enablerowRouting={true}
          redRow={[0]}
        />
      </div>
    </div>
  );
};

export default InitialReviewPage;
